import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterS = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M12.136 16.156C13.888 16.156 15.112 15.22 15.112 13.684C15.112 12.016 13.708 11.584 12.316 11.14C11.092 10.756 10.624 10.48 10.624 9.832C10.624 9.196 11.14 8.788 11.944 8.788C12.88 8.788 13.408 9.292 13.708 9.964L14.872 9.292C14.344 8.176 13.324 7.444 11.944 7.444C10.528 7.444 9.244 8.32 9.244 9.868C9.244 11.452 10.516 11.932 11.824 12.328C13.072 12.712 13.732 12.964 13.732 13.708C13.732 14.32 13.264 14.812 12.172 14.812C11.032 14.812 10.384 14.248 10.084 13.396L8.896 14.092C9.34 15.34 10.48 16.156 12.136 16.156Z" }),
});

export { IconCapitalLetterS };
